/**
 * @file 商业化弹窗命令式 API
 * @description 非 hook 环境下打开会员/积分弹窗的公共函数
 */

import type {MembershipModalSourceType} from './MembershipModal/types';
import type {PointsRechargeModalSourceType} from './PointsRechargeModal/types';
import {useModalStore} from '@/store/useModalStore';

/** 打开会员订阅弹窗 */
export const openMembershipModal = (source?: MembershipModalSourceType) => {
    // 添加来源
    source && useModalStore.getState().setMembershipModalSource(source);
    useModalStore.getState().setMembershipModalOpen(true);
};

/** 打开积分充值弹窗 */
export const openPointsRechargeModal = (source?: PointsRechargeModalSourceType) => {
    // 记录来源（scene_key）用于打点
    source && useModalStore.getState().setPointsRechargeModalSource(source);
    useModalStore.getState().togglePointsRechargeModal(true);
};
